
import Vue from "vue";
import RULES from "@/mixins/rules";
import EventBus from "@/plugins/event-bus";
import EstablecimientoService from "@/services/EstablecimientoService";
import NuevaConstanciaUsoSuelo from "@/components/Establishments/NuevaConstanciaUsoSuelo.vue";

export default Vue.extend({
  name: 'ListadoConstanciaUsoSuelo',
  mixins: [RULES],
  directives: {},
  components: {
    NuevaConstanciaUsoSuelo
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: [],
    },
    locacion: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    headers: [
      { text: "Estatus", value: "estatus_general.descripcion" },
      { text: "Giro", value: "giro_opb.d_giro" },
      { text: "Domicilio", value: "domicilio.domicilio_completo" },
      { text: "Fecha inicio", value: "fecha_tramite_inicio" },
      { text: "Observaciones", value: "motivo_rechazo" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    dialogViewRecibo: false,
    documento: null,
    title: '',
    dialogNuevaConstancia: false,
    nameRoute: null as any,
    handleEsc: null as ((e: KeyboardEvent) => void) | null,
    createNuevaConstancia: true
  }),
  created() {
  },
  mounted() {
    this.nameRoute = this.$route.name;
    EventBus.$on("close-nueva-constancia-uso-suelo", () => {
      this.dialogNuevaConstancia = false;
    });
    EventBus.$on("update-registers", () => {
      this.$emit("update-registers");
      this.close();
    });
    this.handleEsc = (e) => {
      if (e.key === "Escape") {
        this.close();
      }
    };
    document.addEventListener("keydown", this.handleEsc);
  },
  computed: {    
  },
  watch: {
    //Al cambiar los items ejecutar esto
    items() {
      this.createNuevaConstancia = true;
      if (this.items.length == 0) {
        this.createNuevaConstancia = false;
      }
      this.items.forEach((item: any) => {
        console.log(item);
        if (item.estatus_general.id != 4) {
          this.createNuevaConstancia = false;
        }
      });
      if(this.items.length >= 2){
        this.createNuevaConstancia = false;
      }
    }
  },
  methods: {
    modalNuevaConstancia(items: any){
      this.dialogNuevaConstancia = true;
    },
    close() {
      EventBus.$emit("close-listado-constancia-uso-suelo");
    },
    async verConstancia(item: any) {
      let url = `constancia_uso_suelo/${item.id}/imprimirconstancia`;
      let data = {};
      let method = "POST";
      const constancia = item.formato_uso_suelo;
      //const constanciaId = constancia.constancia_id;
      const tipo = constancia.tipo_formato_id;
      //const url = `constancia_uso_suelo/getFormat/${constanciaId}`;
      //await UsoSueloService.getFormat(url, {typeId: tipo}, 'POST', 'Temp')
      await EstablecimientoService.imprimir(url, {typeId: tipo}, method, '')
          .then((response) => {
              let file = new Blob([response.data], { type: response.headers['content-type'] });
              const url = window.URL.createObjectURL(file);
              const tipoArchivo = ''
              //@ts-ignore
              this.documento = {
                  title: tipoArchivo,
                  url: url,
                  mime: response.headers['content-type']
              }
              this.title = 'Constancia de uso de suelo'
              this.dialogViewRecibo = true;
          })
          .catch((error) => {
              this.$toast.error(error.response.data.message)
          })
    }
  }
});

